














import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { Listenable } from '@/util/Listenable';

@Component({
  components: {},
})
export default class EditableTableCell extends Vue {
  @Prop({ required: true }) public cellProperty!: string;
  @Prop({ required: true }) public onReset!: Listenable<boolean>;

  private isChanged: boolean = false;

  mounted()
  {
      this.onReset.listen((isSaved) => {
          this.isChanged = false;
      });
  }

  set newVal(val) {
      this.$emit('update:cellProperty', val);
  }

  get newVal () : string {
      return this.cellProperty;
  }

  private unlock(): void {
      this.isChanged = true;
  }
}
